import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {filter, map} from 'rxjs/operators';
import {notEmpty} from '../../util/type-helper';
import {NotificationHelper} from '../notification/notification-helper';
import {notificationCreate} from '../notification/notification.actions';
import {CdNotification} from '../notification/notification.reducer';
import {autoSaveRequestFailed} from './auto-save.actions';
import {AutoSaveError, isAutoSaveError} from './auto-save.reducer';

@Injectable()
export class AutoSaveEffects {
  constructor(private actions$: Actions) {}

  notificationForError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(autoSaveRequestFailed),
      filter((a): a is ReturnType<typeof autoSaveRequestFailed> & {error: CdNotification | AutoSaveError} => notEmpty(a.error)),
      map(a =>
        notificationCreate({
          notification: !isAutoSaveError(a.error)
            ? a.error
            : NotificationHelper.createCDNotification({type: 'error', showInNotificationCenter: true, title: a.request.operationName, message: a.error.i18nToken})
        })
      )
    )
  );
}
